import React from "react";
import { PanelAddUser } from "../../../../UI/Users/Add/PanelAddUser";
import {AddMembershipService} from "../../../../UI/MembershipService/Add/AddMembershipService";

const AddMembershipServicePage = () => {
  return (
    <div>
      <AddMembershipService />
    </div>
  );
};

export default React.memo(AddMembershipServicePage);
